/**
 * Free-mode title-card policy (03 §10; 06-milestones owner decision #2 "show until first play, then
 * skip"). The shell owns one instance per player and exposes it as `StyleContext.titleCard`; styles
 * draw their own card and query it every frame (Distacchi deviation D-5 works exactly this way).
 * Director parity stays with the style (v6 `title` phase, frames 0–359); this policy only answers
 * for free mode.
 */
import type { ClockApi, TitleCardPolicy } from '../api.ts';

export class FreeTitleCardPolicy implements TitleCardPolicy {
  private played = false;

  constructor(clock: Pick<ClockApi, 'playing' | 'on'>) {
    clock.on('play', () => {
      if (clock.playing) this.played = true;
    });
  }

  /** free mode: t ≤ 0, paused and not played yet; false forever after the first play */
  visible(t: number, playing: boolean): boolean {
    return !this.played && !playing && t <= 0;
  }
}
